import { dispatchSignal } from "../event/private.js";
import { invokeQueueHandlerAsync, invokeQueueHandlerSync } from "../function/invoke.js";
import {
  applyHandler,
  callHandler,
  dispatchHandler,
  isSetHandler,
  subscribeHandler,
  assignEventHandler,
  setEventValueHandler,
  thenHandler,
  toStringHandler,
  withHandler,
  assignNamespaceHandler,
  assignFunctionHandler,
  addEventListenerHandler,
  removeEventListenerHandler,
  getEventValueHandler,
  updateEventValueHandler,
  assignStoreHandler,
} from "./getters.js";
import type { GetterHandler } from "../store/store.types.js";
import * as symbols from "../utils/symbols.js";
import type { AnyFunction } from "../utils/utils.types.js";

/**
 *
 */
export const name = "otto";

export const gettersAsync = {
  set: setEventValueHandler,
  get: getEventValueHandler,
  update: updateEventValueHandler,
  isSet: isSetHandler,
  on: subscribeHandler,
  receive: subscribeHandler,
  subscribe: subscribeHandler,
  sub: subscribeHandler,
  emit: dispatchHandler,
  dispatch: dispatchHandler,
  send: dispatchHandler,
  then: thenHandler,
  apply: applyHandler,
  call: callHandler,
  with: withHandler,
  toString: toStringHandler,
  assignEvent: assignEventHandler,
  assignStore: assignStoreHandler,
  assignNamespace: assignNamespaceHandler,
  assignFunction: assignFunctionHandler,
  addEventListener: addEventListenerHandler,
  removeEventListener: removeEventListenerHandler,
} as Record<string | symbol, undefined | typeof symbols.noop | GetterHandler<unknown>>;

/**
 *
 */
export const reservedKeys: (string | symbol)[] = Object.keys(gettersAsync);

export const gettersSync = { ...gettersAsync, then: symbols.noop } as const;

export type ProxyConfig = [
  getters: typeof gettersAsync,
  dispatchEvent: typeof dispatchSignal,
  invokeQueueHandler: typeof invokeQueueHandlerAsync,
];

export const configAsync: ProxyConfig = [gettersAsync, dispatchSignal, invokeQueueHandlerAsync];

export const configSync: ProxyConfig = [gettersSync, dispatchSignal, invokeQueueHandlerSync];

export const proxies = new WeakMap<ProxyHandler<AnyFunction>, ProxyConfig>();

export function getProxyConfig(handler: ProxyHandler<AnyFunction>): ProxyConfig {
  return proxies.get(handler) as never;
}
